angular.module('internal.eventdetail',[])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('internal.eventdetail', {
            url: '/event/:id/:prevState/:title?preParams',
            views: {
                'content': {
                    templateUrl: 'js/internal/eventdetail/eventdetail.view.html',
                    controller:'EventDetailCtrl'
                }
            }
        });
    }]);